import React from 'react';
import { LinkedinIcon, YoutubeIcon, MailIcon, SendIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-contain bg-no-repeat bg-center relative text-white py-16" style={{
    backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/s2P4MfmUZfnN3rximDrMWJ/if-footer.png')`,
    minHeight: '500px',
    backgroundSize: 'cover'
  }} data-id="element-47" data-mp="3gg0yw2enzvx4">
      <div className="absolute inset-0" data-id="element-48" data-mp="3ufju5umdncs0"></div>
      <div className="container mx-auto px-4 py-12 relative z-10" data-id="element-49" data-mp="38h4x8q3ngkf">
        <div className="flex justify-end" data-id="element-50" data-mp="36muiocgf6ul">
          <div className="text-right max-w-md" data-id="element-51" data-mp="3leviv7odbqit">
            <div className="flex justify-end space-x-6 mb-6" data-id="element-52" data-mp="3le2jwsvni5b8">
              <a href="https://www.linkedin.com/company/improbability-foundation" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors" data-id="element-53" data-mp="3qcnhekjiqavz">
                <LinkedinIcon size={24} data-id="element-54" data-mp="2evxaez79tf1b" />
              </a>
              <a href="https://www.youtube.com/@EverythingElseMatters" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors" data-id="element-55" data-mp="3labrlvxno6qd">
                <YoutubeIcon size={24} data-id="element-56" data-mp="3v5dhwv3o3euj" />
              </a>
            </div>
            <div className="text-sm text-right" data-id="element-57" data-mp="3q7bxa5qlf7gy">
              <p className="mb-4" data-id="element-58" data-mp="82icbryzq8eb">© 2026, Improbability Foundation</p>
              <p className="mb-4" data-id="element-59" data-mp="80ntcj7a4qcv">c/o Reliance Trust Company SA <br data-id="element-60" data-mp="32w45wy0ricd" />
                Rue De-Candolle 19,<br data-id="element-61" data-mp="31umvaqetzm7" />
                1205 Genève, Switzerland
              </p>
              <div className="flex flex-col space-y-2 mt-4" data-id="element-62" data-mp="hs1yb6i02ide">
                <a href="mailto:hq@improbability.foundation" className="inline-flex items-center justify-end hover:text-blue-300 transition-colors" data-id="element-63" data-mp="ctgvr0f9zmls">
                  <span data-id="element-64" data-mp="msppbs68az7m">Email Us</span>
                  <MailIcon size={16} className="ml-2" data-id="element-65" data-mp="mtraipgyl232" />
                </a>
                <a href="https://t.me/improbabilityfoundation" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-end hover:text-blue-300 transition-colors" data-id="element-66" data-mp="twfnps3h9trd">
                  <span data-id="element-67" data-mp="18k97zq3idkga">Telegram</span>
                  <SendIcon size={16} className="ml-2" data-id="element-68" data-mp="18lbxpup3hgum" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}